<template>
    <div class="l-ss-c-results-empty-filters">
        <empty-results-header @reset-filters="emitResetFilters"/>
        <div
            class="l-ss-c-results-empty-filters-offers-wrapper"
            v-if="popularOffers.length">
            <offers-wrapper
                :key="offerLayout"
                :view="view"
                :offer-layout="offerLayout"
                :breakpoint="currentBreakpoint"
                :offers="popularOffers"
                v-on="offersWrapperEventListeners"/>
        </div>
    </div>
</template>

<script>
    import { ref, computed, onBeforeUnmount } from '@vue/composition-api';

    import iconFilterRemove from '@/core/assets/images/icons/filter-remove.svg';
    import OffersWrapper from '@/core/components/offers-wrapper.vue';

    import getCurrentBreakpoint from '@/core/helpers/get-current-breakpoint';
    import EmptyResultsHeader from '@/core/components/section-results/empty-results-header.js';
    import EventEmitterMixin from '@/core/mixins/event-emitter';
    import { commonOfferEventHandlers, mapHandlers } from '@/core/mixins/event-emitter';

    export default {
        components: { EmptyResultsHeader, OffersWrapper },
        mixins: [EventEmitterMixin],
        props: {
            popularOffers: {
                type: Array,
            },
            mobile: {
                type: Boolean,
                default: false,
            },
            configuration: {
                type: Object,
            },
        },
        setup(props) {
            const defaultBreakpoint = {
                columnCount: 4,
            };
            const currentBreakpoint = ref(defaultBreakpoint);
            const breakpoints = props.configuration.layout.emptyResultsBreakpointsFromFilters;
            const placesForLayout = props.configuration.placesForOfferLayout;

            const calcCurrentBreakpoint = () => {
                currentBreakpoint.value = getCurrentBreakpoint(breakpoints, window.innerWidth);
            };

            if (breakpoints) {
                calcCurrentBreakpoint();
                window.addEventListener('resize', calcCurrentBreakpoint);
            }

            const offerLayout = computed(() => {
                return currentBreakpoint.value.offerLayout ||
                    (!props.mobile ?
                        placesForLayout.noResultsFromFilters :
                        placesForLayout.mobileNoResultsFromFilters);
            });

            const view = computed(() => {
                return currentBreakpoint.value.columnCount > 1 || props.mobile ? 'grid' : 'row';
            });

            onBeforeUnmount(() => {
                window.removeEventListener('resize', calcCurrentBreakpoint);
            });

            return {
                iconFilterRemove,
                currentBreakpoint,
                offerLayout,
                view,
            };
        },
        computed: {
            offersWrapperEventListeners() {
                return {
                    ...mapHandlers(this, commonOfferEventHandlers),
                };
            },
        },
    };
</script>
